import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import PlaceholderPage from "@/components/pages/placeholder-page";

const AppAboutPage = (): JSX.Element => <PlaceholderPage name="About" />;

export const Route = createFileRoute("/_app/about/")({
	component: AppAboutPage,
});
